<template>
  <custom-dialog width="400px" :showClose="true" v-if="bargainDialog.show" :visible="bargainDialog.show"
    @close="closeBargainDialog">
    <div slot="header" class="discount_header">
      <div class="discount_header_title">{{ bargainDialog.discountType == 3 ? '至尊卡折扣' : '自定义折扣' }} </div>
      <div class="discount_header_tips">挂号费不参与议价</div>
    </div>
    <div slot="content">
      <div class="discount_item">
        <div class="discount_item_label">可折扣金额：</div>
        <div class="discount_item_value">￥{{ bargainDialog.amount }}</div>
        <el-popover placement="bottom-start" trigger="hover">
          <div class="noStackingProject_list">
            <div v-for="(item, index) in noStackingProject.list" :key="index" class="noStackingProject_item">
              <div>{{ index + 1 }}.{{ item.label }}：</div>
              <div>￥{{ item.price }}</div>
            </div>
          </div>
          <div class="discount_item_tips" slot="reference">（有￥{{ noStackingProject.price }}不参与折扣）</div>
        </el-popover>
      </div>
      <div class="discount_item" v-if="bargainDialog.discountType == 3">
        <div class="discount_item_label">折扣比例：</div>
        <div class="discount_item_discountRate">{{ $bigNumber(bargainDialog.discountRate,'/',10) }}折</div>
      </div>
      <div class="discount_item">
        <div class="discount_item_label">折扣金额：</div>
        <div class="discount_item_value">￥{{ -bargainDialog.discountAmount > 0 ? `+${-bargainDialog.discountAmount}` : -bargainDialog.discountAmount }}</div>
      </div>
      <div class="discount_action" v-if="bargainDialog.discountType != 3">
        <el-select class="discount_action_select" v-model="bargainDialog.discountType" placeholder="请选择"
          @change="typeChange">
          <el-option label="按比例折扣（%）" :value="1"></el-option>
          <el-option label="按金额折扣" :value="2"></el-option>
        </el-select>
        <el-input-number v-if="bargainDialog.discountType == 1" class="discount_action_input" :max="100" :min="1"
          v-model="bargainDialog.discountRate" @change="handleDiscount"></el-input-number>
        <el-input-number v-if="bargainDialog.discountType == 2" class="discount_action_input" :min="0"
          v-model="bargainPrice" @change="bargainPriceChange"></el-input-number>
        <div v-if="bargainDialog.discountType == 1" class="recover" @click="recover">恢复</div>
      </div>
      <div class="btns">
        <el-button @click="closeBargainDialog">取消</el-button>
        <el-button  type="primary" @click="bargainComfirm"> {{ bargainDialog.discountType == 3 ? '确定使用' : '确定' }}</el-button>
      </div>
    </div>
    <div slot="footer"></div>
  </custom-dialog>
</template>

<script>
import CustomDialog from '@/components/customDialog/CustomDialog'
import { Utils } from '@/utils/utils'
import { deepClone, debounce, isNull } from '@/utils/validateBase'
import { positiveNum } from '@/utils/regexp'
export default {
  // 定义引入的组件
  components: { CustomDialog },
  props: {
    bargainDialog: {
      type: Object,
      value: {}
    },
  },
  data() {
    return {
      bargainPrice: ''
    }
  },
  //变量监听
  watch: {},
  // 页面初始化
  created() { },
  // 页面DOM加载完成
  mounted() { },
  //离开页面时执行
  destroyed() { },
  computed: {
    noStackingProject() {
      let list = []
      let price = 0
      if (!isNull(this.bargainDialog.registerPrice)) {
        price = this.$bigNumber(price, '+', this.bargainDialog.registerPrice)
        list.push({ label: '挂号费', price: this.bargainDialog.registerPrice })
      }
      this.bargainDialog.noStackingActivityList.forEach(v => {
        price = this.$bigNumber(price, '+', v.totalPrice)
        list.push({ label: v.actName, price: v.totalPrice })
      })

      let giftGoodNum = 0
      this.bargainDialog.giftGoodList.forEach(v => {
        giftGoodNum = giftGoodNum + v.itemTotal
      })
      if (giftGoodNum > 0) {
        price = this.$bigNumber(price, '+', (Math.round(giftGoodNum * 0.01 * 100) / 100))
        list.push({ label: '满额换购', price: (Math.round(giftGoodNum * 0.01 * 100) / 100) })
      }
      return { list: list, price: price }
    }
  },
  // 页面方法
  methods: {
    /**
     * 恢复
     */
    recover() {
      this.bargainDialog.discountRate = 100
      this.bargainDialog.discountAmount = 0
      this.$forceUpdate()
    },
    /**
    * 折扣改变
    */
    handleDiscount(val) {
      if (isNull(val)) return
      if (Utils.gt(val, 100)) {
        this.$message.error('折扣不能大于100！')
        this.bargainDialog.discountRate = 100
      } else {
        this.bargainDialog.discountRate = val
        let temp = this.$bigNumber(val, '/', 100)
        this.bargainDialog.discountAmount = this.$bigNumber(this.bargainDialog.amount,'-', this.$bigNumber(this.bargainDialog.amount, '*', temp,2))
      }
      this.$forceUpdate()
    },
    /**
    * 关闭议价弹框
    */
    closeBargainDialog() {
      this.$emit('close')
    },
    /**
    * 议价确定弹框
    */
    bargainComfirm() {
      this.$emit('save', this.bargainDialog)
    },
    typeChange(val) {
      if (val == 2) {
        this.bargainPrice = this.bargainDialog.amount
      }
      this.bargainDialog.discountAmount = 0
      this.$forceUpdate()
    },
    bargainPriceChange(){
      this.bargainDialog.discountAmount = this.$bigNumber(this.bargainDialog.amount,'-',this.bargainPrice,2)
      this.$forceUpdate()
    },
  },
}
</script>
<style lang="less" scoped>
.registerPrice {
  color: #667182;
  position: absolute;
  right: 70px;
}

.discountPrice {
  color: #667182;
  font-size: 14px;
}


.discount_header {
  height: 48px;
  display: flex;
  align-items: center;
  border-bottom: 1px solid #E0E0E0;
  padding: 0 20px;
}

.discount_header_title {
  font-weight: 600;
  font-size: 16px;
  color: #000000;
}

.discount_header_tips {
  width: 120px;
  height: 22px;
  background: linear-gradient(90deg, #E0F1FF 0%, rgba(224, 241, 255, 0.05) 100%);
  border-radius: 2px;
  font-weight: 400;
  font-size: 12px;
  color: #1890FF;
  margin-left: 6px;
  line-height: 22px;
  padding-left: 4px;
}

.discount_item {
  display: flex;
  font-size: 14px;
  margin-bottom: 20px;
  align-items: center;
}

.discount_item_label {
  width: 85px;
  text-align: right;
}

.discount_item_value {
  color: #667182;
}

.discount_item_value {
  font-size: 600;
  color: #000;
}

.discount_action {
  display: flex;
  height: 36px;
  border: 1px solid #D3D3D5;
  border-radius: 2px;
  position: relative;
}

.discount_action_select {
  width: 150px;
  flex-shrink: 0;

  /deep/.el-input__inner {
    height: 36px;
    padding: 0 13px;
    border: none;
    background: #F7F8F9;
    border-right: 1px solid #D3D3D5;
  }
}

.discount_action_input {
  width: 100%;

  /deep/.el-input__inner {
    height: 36px;
    padding: 0 13px;
    border: none;
    text-align: left;
  }

  /deep/.el-input-number__decrease,
  /deep/.el-input-number__increase {
    display: none;
  }
}

.recover {
  color: #1890FF;
  font-size: 14px;
  cursor: pointer;
  position: absolute;
  top: 50%;
  right: 13px;
  transform: translateY(-50%);
}

.btns {
  display: flex;
  justify-content: flex-end;
  margin-top: 20px;
}

.discount_item_discountRate {
  padding: 1px 6px;
  border-radius: 2px;
  border: 1px solid #1890FF;
  box-sizing: border-box;
  font-weight: 400;
  font-size: 14px;
  color: #1890FF;
}

.noStackingProject_list {}

.noStackingProject_item {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  line-height: 24px;
}

.discount_item_tips {
  font-size: 14px;
  color: #509863;
  cursor: default;
  user-select: none;
}
</style>